'use client';

import { useHubSpotForm } from './useHubSpotForm';

interface HubSpotFormEmbedProps {
  formId: string;
  sysId?: string;
}

export const HubSpotFormEmbed = ({ formId, sysId }: HubSpotFormEmbedProps) => {
  const { iframeRef, tagsUrl } = useHubSpotForm(formId, sysId);

  if (!tagsUrl) return null;

  return (
    <iframe
      ref={iframeRef}
      title="HubSpot"
      id={`hubspot-iframe-${sysId}`}
      src={tagsUrl}
      sandbox="allow-scripts allow-forms allow-same-origin allow-top-navigation allow-popups allow-popups-to-escape-sandbox"
      style={{
        width: '100%',
        height: '500px',
        border: 0,
        scrollMargin: '100px',
      }}
      data-testid="hubspotFormContainer"
    />
  );
};
